import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import styles from './index.module.css';

export const Button = ({
  smalltext,
  alignCenter,
  blockText,
  blockTextProMax,
  children,
  className,
  glow,
  isBlack,
  isBlue,
  isDarkBlue,
  isDisabled,
  isFullWidth,
  MobWidth,
  isGray,
  isLarge,
  isOutlined,
  isWhite,
  itsBlack,
  link,
  isGrayWhiteText,
  isTopMargin,
  isTopMargin15,
  submit,
  id,
  ...props
}) => {
  const Element = link ? Link : submit ? 'input' : 'button';
  const elementProps = {
    ...props,
    disabled: isDisabled,
    ...(link && { to: link }),
    ...(!submit && { children }),
    ...(submit && { type: 'submit', value: children }),
    id
  };

  return (
    <Element
      className={cn({
        [styles.marginTop]: isTopMargin,
        [styles.marginTop15]: isTopMargin15,
        [styles.itsBlack]: itsBlack,
        [styles.smalltext]: smalltext,
        [styles.grayWhiteText]: isGrayWhiteText,
        [styles.blockText]: blockText,
        [styles.blockTextProMax]: blockTextProMax,
        [styles.button]: true,
        [styles.alignCenter]: alignCenter,
        [styles.glow]: glow,
        [styles.outlined]: isOutlined,
        [styles.large]: isLarge,
        [styles.blackColor]: isBlack,
        [styles.blueColor]: isBlue,
        [styles.darkblueColor]: isDarkBlue,
        [styles.grayColor]: isGray,
        [styles.whiteColor]: isWhite,
        [styles.fullWidth]: isFullWidth,
        [styles.mobWidth]: MobWidth,
        [className]: className,
      })}
      {...elementProps}
    />
  );
};
